import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  DeviceInfoSetting,
  LocalService,
} from '../../../service/local.service';
import { ReplaceFonts, ReplaceFontType } from 'src/app/supporting/replaceFont';
import { HttpClient } from '@angular/common/http';
import { PrintContent, PrintData } from 'src/app/entities/offline';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.scss'],
})
export class PrintComponent implements OnInit {
  @Input() content: string;
  @Input() printWidth: number = 800;
  @Input() fileName: string = 'file';
  @Output() onPrinted = new EventEmitter();
  isPrint: boolean = false;
  @Input() printLanguageCode = '';
  @Input() isQrCodePrint = false;

  elementIds: any;
  htmlId: string = '';
  isOldPrintEnable: boolean | null = null;
  @Input() isFontPathCss = false;

  constructor(
    public localService: LocalService,
    private http: HttpClient,
  ) { }

  ngOnInit(): void {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      receipt_iframe_print: 'receipt_iframe_print_' + this.htmlId,
    };
  }

  ngAfterViewInit() {
    if (this.printLanguageCode == '') {
      this.printLanguageCode = this.localService.selected.applicationLanguage;
    }

    this.isPrint = this.content && this.content != '';
    if (this.isPrint) this.onPrint();
  }

  ngOnDestroy(): void {
    this.content = '';
  }

  ngOnChanges(): void { }

  onPrint() {
    const currentDevice = this.localService.onGetCurrentDeviceSettingsOfBusiness();
    if (!this.isQrCodePrint && currentDevice.DirectPrintUrl && currentDevice.DirectPrintUrl.length > 5) {
      this.onPrintDirectUrl(currentDevice);
    }
    else {
      this.onSetToIframe();
    }
  }

  onPrintDirectUrl(currentDevice: DeviceInfoSetting) {
    if (this.content && this.content.length > 5) {
      const payload = {
        dt: {
          values: [
            {
              htmlContent: this.content,
              printerNames: [],
            } as PrintContent,
          ],
        } as PrintData,
      };

      this.http
        .post(currentDevice.DirectPrintUrl + 'printer/set-print', payload)
        .subscribe({
          next: (response) => {
            this.isPrint = false;
            this.onPrinted.emit();
          },
          error: (error) => {
            console.error('Direct print failed:', error);
          },
        });
    } else {
      this.isPrint = false;
      this.onPrinted.emit();
    }
  }


  onSetToIframe() {
    if (this.content && this.content.length > 5) {
      this.content = ReplaceFonts(
        this.content,
        this.isFontPathCss
          ? ReplaceFontType.FontPath
          : ReplaceFontType.FontName,
      );
      setTimeout(() => {
        const iframe: any = document.getElementById(
          this.elementIds.receipt_iframe_print,
        );

        if (iframe) {
          let doc = iframe.contentWindow || iframe.contentDocument;
          if (doc.document) doc = doc.document;

          doc.open();
          doc.write(this.content);
          doc.close();

          iframe.onload = function () {
            //iframe.style.height = (iframe.contentWindow.document.body.scrollHeight) + 'px';

            setTimeout(() => {
              if (iframe.contentWindow && iframe.contentWindow.document) {
                const tbl =
                  iframe.contentWindow.document.getElementById('tbl-content');
                if (tbl) {
                  if (tbl.className.indexOf('not-a4') > -1) {
                    let classWidth: string = tbl.style.width;
                    if (classWidth.indexOf('mm')) {
                      const widthInMM = classWidth.split('mm')[0];
                      classWidth = parseInt(widthInMM) + 1 + 'mm';
                      iframe.style.width = classWidth;
                    }
                  } else if (tbl.className.indexOf('fixed-') > -1) {
                    const classNames = tbl.className.split(' ');
                    const finalClassName = classNames.find(
                      (x) => x.indexOf('fixed-') > -1,
                    );

                    if (finalClassName) {
                      let classWidth: string;

                      for (const sheet of Array.from(
                        iframe.contentWindow.document.styleSheets,
                      )) {
                        if (!classWidth) {
                          try {
                            const rules = (sheet as CSSStyleSheet).cssRules;
                            const rule = Array.from(rules).find(
                              (x) => x['selectorText'] == '.' + finalClassName,
                            );
                            if (rule) {
                              classWidth = rule['style'].width;
                            }
                          } catch (e) {
                            // Skip cross-origin stylesheets
                            continue;
                          }
                        }
                      }

                      if (classWidth) {
                        iframe.style.width = classWidth;
                      }
                    }
                  } else {
                    const width = tbl.style.width;
                    iframe.style.width = width;
                  }
                }
              }
            }, 200);
          };

          // Wait for iframe to render and fonts to load
          setTimeout(async () => {
            try {
              if (iframe.contentWindow) {
                // Use FontFaceSet API to wait for font load
                await iframe.contentDocument?.fonts.load('1em EnglishFont');
                await iframe.contentDocument?.fonts.ready;

                iframe.contentWindow.onafterprint = () => {
                  this.isPrint = false;
                  this.onPrinted.emit();
                };

                // Print after font is ready
                iframe.contentWindow?.print();
              }
            } catch (error) {
              console.error('Font loading failed:', error);
            }
          }, 0); // slight delay to let rendering start
        }
      }, 0);
    }
  }
}
